/* eslint-disable camelcase */

// DEPENDENCIES
import React, {
  useEffect,
  useState,
} from 'react';
import { connect } from 'react-redux';
import jwt_decode from 'jwt-decode';
import {
  Switch,
  Route,
  Redirect,
  useLocation,
} from 'react-router-dom';
import { enableBodyScroll } from 'body-scroll-lock';
// ROUTES
import PrivateRoute from './routes/PrivateRoute';
// CUSTOM COMPONENTS
import ConfirmModal from './components/ConfirmModal';
import AlertToast from './components/AlertToast';
// AUTHENTICATION
import LoginPage from './pages/admin/authentication/LoginPage';
// MANAGEMENT PAGES - SYSTEM
import UserListingPage from './pages/admin/management/system/user/UserListingPage';
import UserProfilePage from './pages/admin/management/system/user/UserProfilePage';
import GroupListingPage from './pages/admin/project/inventory/GroupListingPage';
// PROJECT
import LicensorListingPage from './pages/admin/project/inventory/LicensorListingPage';
import LicensorManagementPage from './pages/admin/project/inventory/LicensorManagementPage';
import QuoteListingPage from './pages/admin/project/inventory/QuoteListingPage';
import QuoteManagementPage from './pages/admin/project/inventory/QuoteManagementPage';
// -- Project
// -- WALL CHART
// -- EQUIPMENT
// -- STATUS
// -- CLIENT
import ClientListingPage from './pages/admin/project/management/client/ClientListingPage';
import ClientManagementPage from './pages/admin/project/management/client/ClientManagementPage';
// --  CONTRACTOR
// -- COMPONENTS
// -- MENU ITEMS

const Routes = (props) => {
  const { auth } = props;
  const [isAuthorized, setIsAuthorized] = useState(true);
  const { pathname } = useLocation();

  useEffect(() => {
    const body = document.querySelector('body');
    window.scrollTo(0, 0);
    enableBodyScroll(body);
  }, [pathname]);

  const validateAccess = () => {
    if (auth.authToken !== '') {
      try {
        const decodedToken = jwt_decode(auth.authToken);
        setIsAuthorized(decodedToken);
      } catch (ex) {
        setIsAuthorized(false);
      }
    } else {
      setIsAuthorized(false);
    }
  };

  useEffect(() => {
    validateAccess();
  }, [auth]);

  return (
    <>
      <AlertToast />
      <ConfirmModal />

      <Switch>
        <Redirect
          exact
          from="/"
          to="/quotes"
        />
        <Route
          path="/login"
          component={LoginPage}
        />

        {
          isAuthorized
            ? (
              <>
                {/* MANAGEMENT PAGES - SYSTEM */}
                <PrivateRoute
                  path="/management/users"
                  component={UserListingPage}
                  title="Manage Users"
                />

                <PrivateRoute
                  path="/my-profile"
                  component={UserProfilePage}
                  title="My Profile"
                />

                {/* CLIENT MANAGEMENT */}
                <PrivateRoute
                  path="/management/customers"
                  component={ClientListingPage}
                  title="Manage Customers"
                />

                <PrivateRoute
                  exact
                  path="/management/customer"
                  component={ClientManagementPage}
                  title="Add Customer"
                />

                <PrivateRoute
                  exact
                  path="/management/client/edit/:clientId"
                  component={ClientManagementPage}
                  title="Manage Client"
                />

                <PrivateRoute
                  exact
                  path="/groups"
                  component={GroupListingPage}
                  title="Manage Groups"
                />

                <PrivateRoute
                  exact
                  path="/licensors"
                  component={LicensorListingPage}
                  title="Manage Licensors"
                />

                <PrivateRoute
                  exact
                  path="/quotes"
                  component={QuoteListingPage}
                  title="Manage Quotes"
                />

                <PrivateRoute
                  exact
                  path="/quote"
                  component={QuoteManagementPage}
                  title="Create Quote"
                />

                <PrivateRoute
                  exact
                  path="/quote/:quoteId"
                  component={QuoteManagementPage}
                  title="Manage Quote"
                />

                <PrivateRoute
                  exact
                  path="/licensor/:licensorId"
                  component={LicensorManagementPage}
                  title="Manage Licensor"
                />
              </>
            )
            : <Redirect to="/login" />
        }
      </Switch>
    </>
  );
};

const mapStateFromProps = (state) => ({ auth: state.auth });

export default connect(mapStateFromProps, null)(Routes);